import {useState} from "react";
import SearchClientModal from "@manual_encounters/encounter_client_search/SearchClientModal";
import {FeatureToggle} from "@/api/dto/dto";
import {useFeatureToggles} from "@/hooks/useFeatureToggles";
import {useRosterStore} from "@/store/roster_store";
import Helpers from "@/helpers/helpers";
import CreateEditClientModal from "@manual_encounters/encounter_admit/pings/CreateEditClientModal";
import CreateEditClientModalNew from "@manual_encounters/encounter_admit/pings/CreateEditClientModalNew";
import {EncounterClient} from "@/api/dto/encounter";
import ReconcileHookModal from "@manual_encounters/encounter_reconcile/pings/ReconcileHookModal";

interface CreateAdmissionProps {
  hideModal: () => void,
}
export const ADMIT_PATIENT = 'EDIT_PATIENT';
export const SEARCH_PATIENT = 'SEARCH_PATIENT';
export const RECONCILE_PATIENT = 'RECONCILE_PATIENT';

const CreateAdmission = (props: CreateAdmissionProps) => {
  const {currentRoster} = useRosterStore();
  const {checkBooleanToggle} = useFeatureToggles();
  const [selectedPatient, setSelectedPatient] = useState<EncounterClient | undefined>(undefined);
  const [step, setStep] = useState(SEARCH_PATIENT);

  function handleHideChooseModal() {
    props.hideModal();
    setSelectedPatient(undefined);
    setStep(SEARCH_PATIENT);
  }

  function handleSelectPatient(patient: EncounterClient | undefined) {
    setSelectedPatient(patient);
    if(patient?.currentlyAdmitted){
      setStep(RECONCILE_PATIENT);
    }else if(Helpers.isDefined(patient)){
      setStep(ADMIT_PATIENT);
    }
  }

  function renderModal(){
    switch (step) {
    case ADMIT_PATIENT:
      return (
        checkBooleanToggle(FeatureToggle.CARECO_3833_REACT_HOOK_FORM_REFACTOR) ? (
          <CreateEditClientModalNew
            hideModal={handleHideChooseModal}
            admittingGroup={currentRoster!}
            patient={selectedPatient!}
            type={'admit'}
          />
        ) : (
          <CreateEditClientModal
            hideModal={handleHideChooseModal}
            admittingGroup={currentRoster!}
            patient={selectedPatient!}
            type={'admit'}
          />
        )
      );
    case RECONCILE_PATIENT:
      return (
        <ReconcileHookModal
          patientDetail={selectedPatient}
          hideModal={handleHideChooseModal}
          group={currentRoster}
          setStep={() => setStep(ADMIT_PATIENT)}
        />
      );
    case SEARCH_PATIENT:
    default:
      return (
        <SearchClientModal
          admittingGroup={currentRoster}
          hideModal={handleHideChooseModal}
          setSelectedPatient={handleSelectPatient}
        />);
    }
  }

  return renderModal();
};

export default CreateAdmission;
